import _cloneDeep from "lodash/cloneDeep";
import { LoggingModule } from "@pns-fe/sdk-common-modules";
import { StorageName } from "../../../constants/sdk";
import BaseStorageWrapper, { DATA_TEMPLATE } from "./BaseStorageWrapper";
const INIT_CONSENT_STORE_DATA = {
  [StorageName.ENTITIES]: _cloneDeep(DATA_TEMPLATE),
  [StorageName.COLLECTION_POINTS]: _cloneDeep(DATA_TEMPLATE)
};
const INIT_NOTIFICATION_STORE_DATA = {
  [StorageName.NOTIFICATIONS]: _cloneDeep(DATA_TEMPLATE)
};
class InMemStorageWrapper extends BaseStorageWrapper {
  constructor() {
    super("InMemStorageWrapper");
    this.insertConsentData = (data, timestamp, userInfo) => {
      LoggingModule.info(`[${this.name}]: insertConsentData`, {
        data,
        timestamp,
        userInfo
      });
      try {
        this.insertConsentDataIntoStore(data, timestamp, userInfo);
      } catch (error) {
        LoggingModule.error(`[${this.name}]: insert - ${error.message}`, error);
      }
    };
    this.insertNotificationData = (data, timestamp, userInfo) => {
      LoggingModule.info(`[${this.name}]: insertNotificationData`, {
        data,
        timestamp,
        userInfo
      });
      try {
        const store = this.getNotificationStore(userInfo);
        this.insertDataByStorageName(store, StorageName.NOTIFICATIONS, data, timestamp);
      } catch (error) {
        LoggingModule.error(`[${this.name}]: insert - ${error.message}`, error);
      }
    };
    this.getConsentStore = (userInfo) => {
      this.cleanUpUnrelatedUserData(userInfo);
      return this._consentStore;
    };
    this.getNotificationStore = (userInfo) => {
      return this._notificationStore;
    };
    this.cleanConsentData = () => {
      this._consentStore[StorageName.COLLECTION_POINTS] = _cloneDeep(DATA_TEMPLATE);
      this._consentStore[StorageName.ENTITIES] = _cloneDeep(DATA_TEMPLATE);
    };
    this.cleanNotificationData = () => {
      this._notificationStore[StorageName.NOTIFICATIONS] = _cloneDeep(DATA_TEMPLATE);
    };
    this.clean = () => {
      this._consentStore = _cloneDeep(INIT_CONSENT_STORE_DATA);
      this._notificationStore = _cloneDeep(INIT_NOTIFICATION_STORE_DATA);
    };
    this.destruct = () => {
      this.clean();
    };
    this.clean();
  }
}
var InMemStorageWrapper_default = InMemStorageWrapper;
export {
  InMemStorageWrapper_default as default
};
